(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("practicalEvaluationHistory", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/practicalEvaluations/practicalEvaluationHistoryView.html",
            controller: ["authService", "practicalEvaluationHistoryResource", "$scope", "_", "$translate", "$state", "DTOptionsBuilder", PracticalEvaluationHistoryCtrl],
            controllerAs: "vm"
        };
        function PracticalEvaluationHistoryCtrl(authService, practicalEvaluationHistoryResource, $scope, _, $translate, $state, DTOptionsBuilder) {
            var vm = this;
            vm.pageHeader = $translate.instant("common.loading");
            vm.code = $state.params.code;
            vm.person = $state.params.person;
            vm.assignmentId = $state.params.assignmentId;
            vm.isSuperAdmin = _.includes(authService.authentication.roles, "Super Admin");
            vm.isContinue = false;
            vm.isLoading = true;
            vm.showAddButton = false;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withPaginationType("full_numbers")
                .withOption("rowCallback", rowCallback)
                .withOption("order", [1, "desc"])
                .withBootstrap();
            vm.dtColumnDefs = [
                {
                    className: "control",
                    orderable: false,
                    targets: 0
                }
            ];
            practicalEvaluationHistoryResource.getHistoryViewModel({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId }, function (data) {
                vm.assignment = data;
                //Check if Resume Evaluation button is needed
                var last = _.last(data.activations);
                if (last && !last.completedDate) {
                    vm.isContinue = true;
                }
                vm.practicalEvaluations = _.filter(data.activations, function (activation) {
                    return !_.isNull(activation.evaluationDate);
                });
                if (vm.assignment.activations.length === 0) {
                    vm.addNew();
                    return;
                }
                if (vm.assignment.activations.length === 1 && _.where(vm.assignment.activations, { evaluationDate: null }).length > 0) {
                    vm.resume();
                    return;
                }
                vm.pageHeader = vm.assignment.userFullName + " - " + vm.assignment.learningItemName + " " + $translate.instant("evaluations.practicalEvaluationHistory.evaluations.title");
                if (data.expiresDate && !vm.isContinue)
                    vm.showAddButton = true;
                vm.isLoading = false;
            });
            //bad bad bad - all this data just to see the completed date of the last activation - moved to getHistoryViewModel processing above
            //practicalEvaluationHistoryResource.getRecent({ code: vm.code, person: vm.person, assignmentId: vm.assignmentId }, function (data) {
            //	if (data.completedDate !== "0001-01-01T00:00:00") {
            //		vm.isContinue = false;
            //	} else {
            //		vm.activationNumber = data.activationNumber;
            //		vm.isContinue = true;
            //	}
            //}, function (error) {
            //	messageService.error(error);
            //});
            vm.showFiles = function (activationNumber) {
                $state.go("main.evaluations.practicalEvaluationHistory.filesModal", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: activationNumber });
            };
            vm.addNew = function addNew() {
                $state.go("main.evaluations.practicalEvaluationsAdd", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
            };
            vm.resume = function () {
                $state.go("main.evaluations.practicalEvaluationsResume", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId });
            };
            function rowClickHandler(row) {
                $state.go("main.evaluations.practicalEvaluationsEdit", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: row[1] });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                if (vm.isSuperAdmin) {
                    $("td:not(.control)", nRow).bind("click", function () {
                        $scope.$apply(function () {
                            rowClickHandler(aData);
                        });
                    });
                }
                return nRow;
            }
        }
    });
}());
